import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthProvider';
import { useNavigate } from 'react-router-dom';

function ForgotPassword(props) {
    const [username, setUsername] = useState('');
    const {forgotPassword} = useContext(AuthContext);
    const navigate = useNavigate();
  
    const handleSubmit = (e) => {
      e.preventDefault();
      // Handle registration logic, e.g., send data to API
      forgotPassword(username);
      navigate('/new-password');
    };
  
    return (
      <div className="App-body">
      <form onSubmit={handleSubmit}>
        Forgot Password
        <div align="center">
        <input
          type="username"
          placeholder="username"
          value={username}
          className="text-box-style"
          onChange={(e) => setUsername(e.target.value)}
        /></div>
        <div align="center">
        <button type="submit">Reset Password</button></div>
      </form></div>
    );
  }

  export default ForgotPassword;